import * as React from 'react'
import { Redirect, Route, RouteComponentProps, RouteProps } from 'react-router'

interface ProtectedRoute extends RouteProps {
  authorized: boolean
  component?: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>
  render?: () => JSX.Element
  redirectPath: string
}

const ProtectedRoute = ({ authorized, redirectPath, ...routeProps }: ProtectedRoute) =>
  authorized ? <Route {...routeProps} /> : <Redirect to={redirectPath} />

export default ProtectedRoute



// WEBPACK FOOTER //
// ./src/components/ProtectedRoute/index.tsx